import { render } from "./ChooseZipFileModal.vue?vue&type=template&id=9194e73a"
import script from "./ChooseZipFileModal.vue?vue&type=script&lang=ts"
export * from "./ChooseZipFileModal.vue?vue&type=script&lang=ts"
script.render = render

export default script